// extracted by mini-css-extract-plugin
export default {"container":"card-details_container__0a7ea"};